<template>
  <div class="relative applicant_profile_modal" :class="{ is_modal: payload.modal_id != undefined }">
    <div v-if="is_loading" class="loading"></div>
    <iframe v-else :src="pdf_src" width="100%" height="100%" class="iframe"></iframe>
  </div>
</template>
<script>
export default {
  name: 'applicant-profile-pdf',
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      is_loading: true,
      pdf_src: undefined
    }
  },
  created () {
    const envData = {
      certification_date: !['Piola'].includes(this.$settings.get({ path: 'operation_name' }))
    }
    this.$network_utils.previewApplicantProfilePDF({
      id: this.payload.applicant_id,
      manual_text: this.payload.manual_text,
      applicant_profile_sections_visibility: { ...this.payload.sections_visibility, ...envData }
    }).then(response => {
      let blob_file = new Blob([response], { type: 'application/pdf' })
      let blob_file_url = URL.createObjectURL(blob_file)
      this.pdf_src = blob_file_url + '#toolbar=0&navpanes=0&zoom=100'
      this.is_loading = false
    })
  }
}
</script>
<style scoped>
  .applicant_profile_modal {
    min-height: 100%;
    height: 100%;
  }
  .applicant_profile_modal.is_modal .iframe {
    display: block;
    height: 80vh;
  }
  </style>
